const SET_EDE_SEARCH_RESULTS_DATA = 'SET_EDE_SEARCH_RESULTS_DATA';
const CLEAR_EDE_SEARCH_RESULTS = 'CLEAR_EDE_SEARCH_RESULTS';

const SET_ID_PROOFING_RESPONSE_DATA = 'SET_ID_PROOFING_RESPONSE_DATA';
const CLEAR_ID_PROOFING_RESPONSE_DATA = 'CLEAR_ID_PROOFING_RESPONSE_DATA';

const SET_BECOME_AOR_RESPONSE_DATA = 'SET_ID_PROOFING_RESPONSE_DATA';
const CLEAR_BECOME_AOR__RESPONSE_DATA = 'CLEAR_ID_PROOFING_RESPONSE_DATA';

const SET_FETCH_ENROLLER_DETAILS_RESPONSE_DATA = 'SET_FETCH_ENROLLER_DETAILS_RESPONSE_DATA';
const CLEAR_FETCH_ENROLLER_DETAILS_RESPONSE_DATA = 'CLEAR_FETCH_ENROLLER_DETAILS_RESPONSE_DATA'; 


export const resultsActionTypes = {
    SET_ID_PROOFING_RESPONSE_DATA,
    CLEAR_ID_PROOFING_RESPONSE_DATA,
    SET_EDE_SEARCH_RESULTS_DATA,
    CLEAR_EDE_SEARCH_RESULTS,
    SET_BECOME_AOR_RESPONSE_DATA,
    CLEAR_BECOME_AOR__RESPONSE_DATA,
    SET_FETCH_ENROLLER_DETAILS_RESPONSE_DATA,
    CLEAR_FETCH_ENROLLER_DETAILS_RESPONSE_DATA
};
